import { Check, LogOut, SkipForward, X } from 'lucide-react'
import type { TransitionAction } from './career-path-types'

/** Get available transition actions for a given stage */
export const getTransitionActions = (
    currentStage: string,
    t: (key: string) => string
): TransitionAction[] => {
    switch (currentStage) {
        case 'intern':
            return [
                {
                    key: 'pass',
                    label: t('career_path.pass_intern'),
                    nextStage: 'probation',
                    icon: <Check className="w-3.5 h-3.5" />,
                    className:
                        'bg-green-50 text-green-700 border-green-200 hover:bg-green-100',
                },
                {
                    key: 'skip',
                    label: t('career_path.skip_to_official'),
                    nextStage: 'official',
                    icon: <SkipForward className="w-3.5 h-3.5" />,
                    className:
                        'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
                },
                {
                    key: 'fail',
                    label: t('career_path.failed'),
                    nextStage: 'offboard',
                    icon: <X className="w-3.5 h-3.5" />,
                    className:
                        'bg-red-50 text-red-700 border-red-200 hover:bg-red-100',
                },
            ]
        case 'probation':
            return [
                {
                    key: 'pass',
                    label: t('career_path.pass_probation'),
                    nextStage: 'official',
                    icon: <Check className="w-3.5 h-3.5" />,
                    className:
                        'bg-green-50 text-green-700 border-green-200 hover:bg-green-100',
                },
                {
                    key: 'fail',
                    label: t('career_path.failed'),
                    nextStage: 'offboard',
                    icon: <X className="w-3.5 h-3.5" />,
                    className:
                        'bg-red-50 text-red-700 border-red-200 hover:bg-red-100',
                },
            ]
        case 'official':
            return [
                {
                    key: 'offboard',
                    label: t('career_path.offboard_action'),
                    nextStage: 'offboard',
                    icon: <LogOut className="w-3.5 h-3.5" />,
                    className:
                        'bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100',
                },
            ]
        default:
            return []
    }
}
